import { Factory } from './_factory';
import { Topic } from '@app/enums/_index';
import { Topics } from '@app/models/_index';

/**
 * Create Topic Factory used by application
 * Creates instances of Topics
 */
export class TopicFactory implements Factory<Topics> {
  topics: Topics[] = [];

  /**
   * Call and build static learning types array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static learning types array to be used to determine the Course learning type
   * Used to show and filter tooltips for a given course detail
   */
  build(): void {
    this.topics.push(
      new Topics(
        Topic.AI_EXPERIENCE,
        'Learn how to leverage AI-driven solutions to enhance customer interactions'
      )
    );
    this.topics.push(
      new Topics(
        Topic.INTEGRATION,
        'Learn how to connect and synchronize Genesys with external systems and applications'
      )
    );
    this.topics.push(
      new Topics(
        Topic.JOURNEY_MANAGEMENT,
        'Discover how to analyze, measure, monitor, and orchestrate customer journeys across your organization'
      )
    );
    this.topics.push(
      new Topics(
        Topic.PLATFORM,
        "Gain a comprehensive understanding of the Genesys Cloud Platform's core capabilities"
      )
    );
    this.topics.push(
      new Topics(
        Topic.WEM,
        'Master the tools that help you manage, engage, and optimize your workforce'
      )
    );
  }

  /**
   * Return immutable or copy of Learning Type collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): Topics[] {
    if (this.topics && this.topics.length === 0) {
      this.build();
    }
    return this.topics.slice();
  }
}
